export default {
	state: {
		PageNo: 0,
		ScrollPosition: '',
		timeSheetFilter: {
			ProjectTitle: '',
			TimeSheetCycle: '',
			ClientName: '',
			EndClientName: '',
			ReportingAuthority: '',
			TimeSheetStatus: [],
			ExpenseStatus:[],
			EmployeeStatus: [],
			InvoiceStatus:[],
			BillingStatus:[],
			ProjectStatus:[],
			FromDate: '',
			ToDate: '',
			TaxTerms: [],
			EmploymentType: [],
		},
		TimesheetCustomMonthlyList: [],
		TimeSheetEmployeeIdList: [],
		TimeSheetSearchText: '',
		ManualRemainderEmpIds: [],
		IsSelectAllForManualRemainders:false,

	},
	mutations: {
		UpdateIsSelectAllForManualRemainders(state, s) {
			state.IsSelectAllForManualRemainders = s;
		},
		UpdateManualRemainderEmpIds(state, s) {
			state.ManualRemainderEmpIds = s;
		},
		updateTimesheetPageNo(state, s) {
			state.PageNo = s;
		},
		updateTimesheetScrollPosition(state, s) {
			state.ScrollPosition = s;
		},
		updateTimeSheetFilterValue(state, p) {
			Vue.set(state.timeSheetFilter, p.field, p.value);
		},
		updateTimesheetCustomMonthlyList(state, s) {
			state.TimesheetCustomMonthlyList = s;
		},
		updateTimeSheetEmployeeIdList(state, s) {
			state.TimeSheetEmployeeIdList = s;
		},
		updateTimeSheetSearchText(state, s) {
			state.TimeSheetSearchText = s;
		}
	},
	getters: {
		getIsSelectAllForManualRemainders(state)
		{
			return state.IsSelectAllForManualRemainders;
		},
		getManualRemainderEmpIds(state) {
			return state.ManualRemainderEmpIds;
		},
		getTimesheetPageNo(state) {
			return state.PageNo;
		},
		getTimesheetScrollPosition(state) {
			return state.ScrollPosition;
		},
		getTimeSheetFilterValue(state) {
			return (field) => {
				return state.timeSheetFilter[field];
			};
		},
		getTimesheetCustomMonthlyList(state) {
			return state.TimesheetCustomMonthlyList;
		},
		getTimeSheetEmployeeIdList(state) {
			return state.TimeSheetEmployeeIdList;
		},
		getTimeSheetSearchText(state) {
			return state.TimeSheetSearchText;
		}
	},
	actions: {
		resetTimeSheetFilter({ state, commit }) {
			commit('updateTimeSheetFilterValue', { field: 'ProjectTitle', value: '' });
			commit('updateTimeSheetFilterValue', { field: 'TimeSheetCycle', value: '' });
			commit('updateTimeSheetFilterValue', { field: 'ClientName', value: '' });
			commit('updateTimeSheetFilterValue', { field: 'EndClientName', value: '' });
			commit('updateTimeSheetFilterValue', { field: 'ReportingAuthority', value: '' });
			commit('updateTimeSheetFilterValue', { field: 'TimeSheetStatus', value: [] });
			commit('updateTimeSheetFilterValue', { field: 'ExpenseStatus',value:[]});
			commit('updateTimeSheetFilterValue', { field: 'EmployeeStatus', value: [] });
			commit('updateTimeSheetFilterValue', { field: 'InvoiceStatus', value: [] });
			commit('updateTimeSheetFilterValue', { field:'BillingStatus',value:[]});
			commit('updateTimeSheetFilterValue', { field: 'ProjectStatus', value: [] });
			commit('updateTimeSheetFilterValue', { field: 'FromDate', value: '' });
			commit('updateTimeSheetFilterValue', { field: 'ToDate', value: '' });
			commit('updateTimeSheetFilterValue', { field: 'EmploymentType', value: [] });
			commit('updateTimeSheetFilterValue', { field: 'TaxTerms', value: [] });
		}
	}
};



// WEBPACK FOOTER //
// ./src/store/modules/Timesheets/index.js